module.exports = __webpack_public_path__ + "img/frame (46).2425baa7.jpg";